module.exports = __webpack_public_path__ + "static/media/p3_s3.1c36f156.ogg";